import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { AppErrors } from '@fitness-force/models';
import { StaffCommissionResponse } from '../models';
import { environment } from '@fitness-force/environments';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root'
})
export class StaffCommissionService {
  private http = inject(HttpClient);

  private readonly API_BASE_URL = environment.APP_URL;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  /**
   * Get current period commission data for logged-in staff
   * @param periodDate - The current date to fetch commission period data
   * @returns Observable of StaffCommissionResponse
   */
  getCurrentPeriodCommissions(periodDate: string): Observable<StaffCommissionResponse> {
    const params = new HttpParams().set('periodDate', periodDate);
    
    return this.http.get<StaffCommissionResponse>(
      this.API_BASE_URL + CONST_URL_SEGEMENTS.COMMISSION.GET_CURRENT_USER_COMMISSIONS,
      { 
        headers: this.httpOptions.headers,
        params 
      }
    ).pipe(
      catchError((error) => {
        return throwError(() => new AppErrors(error));
      })
    );
  }
}

